

const state = {       
    blocks:[
        {
            id:1,
            name: 'Bildupload',
            color: '#fff',  
            columns:1,
            blockcomponents: {
                columns: [
                    //left Column
                    [
                        {
                            id:1,
                            name:'formmediaupload',
                            attributes: {
                                    placeholder:"Lala",
                                    size:"xs12",
                                    invertedsize:"xs1",
                                    hint:"Bildauswahl",
                                    icon:"backup",
                                    variable:"logo_ids",
                                    setter:'entities/ENTITY_SET_LOGOS',
                                    items:'logos/logos',
                            }                                    
                        }
                    ],                  
                ]
            }            
        }
    ]
 
};

export default {
  namespaced: false,
  state,
  
};